export default "__VITE_ASSET__e0rmnQGL__"